import { Component, OnInit } from '@angular/core';

import { AppService } from '../../../services/app.service';
import { NotificationService } from '../../../services/notification.service';
import { ITableColumn } from '../../../shared/table/table.component';
import { INotificationUserChannel, } from '../../../models/Notification';

@Component({
    selector: 'app-notification-channels',
    templateUrl: './notification-channels.component.html',
    styleUrls: ['./notification-channels.component.scss']
})
export class NotificationChannelsComponent implements OnInit {
    constructor(
        private app: AppService,
        private service: NotificationService
    ) { }

    rows: INotificationUserChannel[] = [];

    readonly columns: ITableColumn[] = [
        { label: 'notification_lblNotificationType' },
        { label: 'notification_lblChannels' }
    ];

    ngOnInit() {
        this.fetch();
    }

    update(row: INotificationUserChannel) {
        this.app.addLoading(this.service.updateUserChannels(row.NotificationTypeId, {
            isMyRsuEnabled: row.IsMyRsuEnabled,
            isRsuEmailEnabled: row.IsRsuEmailEnabled,
            isSmsEnabled: row.IsSmsEnabled
        })).subscribe(() => {
            // do nothing
        }, err => {
            this.fetch();
            throw err;
        });
    }

    private fetch() {
        this.app.addLoading(this.service.getUserChannels()).subscribe(data => {
            this.rows = data;
        });
    }
}
